import React from 'react';
import clsx from 'clsx';
import { datasetUrl } from '@/constants/urls';
import {
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnPublisher,
  columnCollections,
  columnStatus,
  columnTools,
  columnUpdatedOn,
  columnVisibility,
  hasColumn,
} from '@/constants/fields';
import SimpleCell from '@/components/table/SimpleCell';
import SystemFlag from '@/components/SystemFlag';
import VisibilityCell from '@/components/table/VisibilityCell';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import MarkdownLinksCell from '@/components/table/MarkdownLinksCell';
import DatasetStatusCell from '../status/containers/DatasetStatusCell';
import DatasetCollectionsCell from '../collections/components/DatasetCollectionsCell';
import { dataModelName, isVisibleDataModel } from '../datamodels/helper';

const DatasetRowWrapper = ({
  children,
  className,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnVisibility,
    columnPublisher,
    columnCollections,
    columnTools,
  ],
  dataset,
  onCheckBoxClick,
  selectable,
  theme,
}) => ((
  <NameDescriptionRow
    className={clsx('aridhia-dataset-row', className)}
    columns={columns}
    description={dataset.catalogue.description}
    entity="dataset"
    href={datasetUrl(dataset)}
    name={dataset.catalogue.title}
    onSelect={() => onCheckBoxClick(dataset.code)}
    renderSystemFlag={() => <SystemFlag messageText={dataModelName(dataset.data_model)} />}
    selectable={selectable}
    selected={dataset.selected}
    system={isVisibleDataModel(dataset.data_model)}
  >
    {hasColumn(columns, columnPublisher) && (
    <MarkdownLinksCell
      items={dataset.catalogue.publishers || dataset.catalogue.publisher}
      theme={theme}
    />
    )}
    {hasColumn(columns, columnCollections) && (<DatasetCollectionsCell collections={dataset.collections} />)}
    {hasColumn(columns, columnVisibility) && (<VisibilityCell visibility={dataset.settings.visibility} />)}
    {hasColumn(columns, columnCreatedOn) && (<SimpleCell content={dataset.createdOn} />)}
    {hasColumn(columns, columnUpdatedOn) && (<SimpleCell content={dataset.updatedOn} />)}
    {hasColumn(columns, columnStatus) && (<DatasetStatusCell dataset={dataset} />)}
    {children}
  </NameDescriptionRow>
));

export default DatasetRowWrapper;
